
import alarmSettingBatch from "./components/alarmSetting-batch.vue";
import alarmSettingOrder from "./components/alarmSetting-order.vue";
import alarmSettingSIM from "./components/alarmSetting-SIM.vue";
import { Component, Vue } from "vue-property-decorator";
import i18n from "@/config/i18n";
import { objAny } from "@/common/common-interface";
@Component({
  components: {
    "alarmSetting-batch": alarmSettingBatch,
    "alarmSetting-order": alarmSettingOrder,
    "alarmSetting-SIM": alarmSettingSIM
  }
})
export default class AlarmSetting extends Vue {
  private privilege: objAny = {};
  private tabsList: object[] = [
    { name: "tab1", title: i18n.t("alarmsetting.tab1"), value: 1 },
    { name: "tab2", title: i18n.t("alarmsetting.tab2"), value: 2 },
    { name: "tab3", title: i18n.t("alarmsetting.tab3"), value: 3 }
  ];
  private tabsActive = "tab1";
  private tab2 = false;
  private tab3 = false;
  public tabChange(data: string): void {
    this.tabsActive = data;
    if (data == "tab2" && !this.tab2) {
      this.tab2 = true;
    } else if (data == "tab3" && !this.tab3) {
      this.tab3 = true;
    }
  }
  mounted() {
    this.privilege = this.$route.meta.privilegeVoObj;
  }
}
